import {
  defaultIntegrations,
  BrowserClient,
  defaultStackParser,
  makeFetchTransport,
  Hub,
  Scope,
} from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { httpClientIntegration } from "@sentry/integrations";

const client = new BrowserClient({
  // all options you normally pass to Sentry.init
  dsn: process.env.REACT_APP_SENTRY_DSN,
  transport: makeFetchTransport,
  stackParser: defaultStackParser,
  // Only the integrations listed here will be used
  integrations: [
    ...defaultIntegrations,
    new BrowserTracing({ tracingOrigins: "*" }),
    httpClientIntegration({
      failedRequestStatusCodes: [400],
      tracing: true,
      breadcrumbCategories: ["xhr", "fetch"],
    }),
  ],
  tracesSampleRate: Number(process.env.REACT_APP_SENTRY_RATE) || 1.0,
});

const sentry = new Hub(client, new Scope());

export default sentry;
